export default class siteHeader {
  constructor() {

    this.navIsOpen = false;
    this.toggleMobileNav.bind(this);
    this.closeSecondNavItems.bind(this);

    let mobileNavBtn = document.querySelector(".header__mobile-nav-menulink-wrapper");
    let mainPage = document.getElementById("main");
    
    this.mobileNavWrapper = document.querySelector(".header__nav-wrapper");
    this.mobileNavClose = document.querySelector(".header__mobile-nav-menu--close");
    this.mobileNavMenu = document.querySelector(".header__mobile-nav-menu--open");
    this.mobileHeader = document.querySelector(".header");
    this.mobileNavList = document.querySelector(".header__nav-list");

    // open mobile nav on click
    if (mobileNavBtn) {
      mobileNavBtn.addEventListener("click", () => {
        this.toggleMobileNav();
      });
    }

    if (mainPage) {
      if ((window.matchMedia("(min-width: 1025px)").matches)) {
        mainPage.addEventListener("mouseenter", () => {
          this.resetExpanders();
          this.resetFirstNavBackground();
          this.closeSecondNavItems();
        });
      }
    }

    // nav first level links
    this.firstLevelItems = document.querySelectorAll(".js-header__nav-item--children");
    this.firstLevelItems.forEach((el) => {
      
      el.addEventListener("click", () => {
        this.toggleNavSecondLevel(el);
      });
      
      if ((window.matchMedia("(min-width: 1025px)").matches)) {
        el.addEventListener("mouseenter", () => {
          this.toggleNavSecondLevel(el);
        });
        el.addEventListener("focus", () => {
          this.toggleNavSecondLevel(el);
        });
      }
    });
  }

  init() {}

  toggleMobileNav() {
    //reset menu divs to closed state
    this.resetExpanders();
    this.resetFirstNavBackground();
    this.closeSecondNavItems();

    this.mobileNavWrapper.classList.toggle("header__mobile_wrapper--open");

    if (this.mobileNavWrapper.classList.contains("header__mobile_wrapper--open")) {
      this.mobileNavMenu.classList.add("header__mobile-nav-menu--hidden");
      this.mobileNavClose.classList.add("header__mobile-nav-menu--shown");
      this.mobileHeader.classList.add("utility-fixed-mobile-menu");
      this.mobileNavList.classList.add("utility-fixed-mobile-menu");
      this.navIsOpen = true;
    } else {
      this.mobileNavMenu.classList.remove("header__mobile-nav-menu--hidden");
      this.mobileNavClose.classList.remove("header__mobile-nav-menu--shown");
      this.mobileHeader.classList.remove("utility-fixed-mobile-menu");
      this.mobileNavList.classList.remove("utility-fixed-mobile-menu");
      this.navIsOpen = false;
    }
  }

  resetFirstNavBackground() {
    let firstLevelLinks = document.querySelectorAll(".header__nav-item-primary");
    firstLevelLinks.forEach((el) => {
      el.classList.remove("header__nav-item--selected-background");
    });
  }
    
  closeSecondNavItems() {
    let secondLevelLinks = document.querySelectorAll(".header__nav-item-secondary");
    secondLevelLinks.forEach((el) => {
      el.classList.add("utility-hidden");
      el.setAttribute("aria-hidden", "true");
    });
  }

  resetExpanders() {
    let expanders = document.querySelectorAll(".header__nav-expander");
    expanders.forEach((el) => {
      el.classList.remove("header__nav-expander--inverse");
    });
  }

  toggleNavSecondLevel(self) {

    //reset menu divs to closed state
    this.closeSecondNavItems();

    let expandIcon_this = self.querySelector(".header__nav-expander");
    let childMenu = self.nextElementSibling;
    
    self.classList.toggle("header__nav-item--selected-background");

    if (expandIcon_this) {
      expandIcon_this.classList.toggle("header__nav-expander--inverse"); 
    }

    if (childMenu) {
      if (self.classList.contains("header__nav-item--selected-background")) {
        childMenu.classList.remove("utility-hidden");
        childMenu.setAttribute("aria-hidden", "false");
          this.navIsOpen = true;
      } else {
        childMenu.classList.add("utility-hidden");
        childMenu.setAttribute("aria-hidden", "true");
          this.navIsOpen = false;
      }
    }

    let firstLevelLinks = document.querySelectorAll(".header__nav-item-primary");
    firstLevelLinks.forEach((el) => {
      if (el != self) {
        el.classList.remove("header__nav-item--selected-background");
      }
    });

    let expanders = document.querySelectorAll(".header__nav-expander");
    expanders.forEach((el) => {
      if (el != expandIcon_this) {
        el.classList.remove("header__nav-expander--inverse");
      }
    });
  }
}
